'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmpty = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _immutable = require('immutable');

var _cwUi = require('cw-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Determines if a value is empty, null or undefined
 * @param {any} value 
 * @returns {boolean}
 */
var isEmpty = exports.isEmpty = function isEmpty(value) {
  // check for undefined and null values
  if (_cwUi.ValueService.IsEmpty(value)) {
    return true;
  }

  if (_immutable.List.isList(value) && value.size === 0) {
    return true;
  }

  if (_immutable.Map.isMap(value) && value.size === 0) {
    return true;
  }

  if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && ((0, _keys2.default)(value).length === 0 || value.length === 0)) {
    return true;
  }

  // check for empty strings
  if (typeof value === 'string' && value.trim() === '') {
    return true;
  }

  return false;
}; // eslint-disable-line


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/ValidationUtilsService.js
// module id = 366
// module chunks = 10